export const CHECKOUT_GIFT_CARDS = {
  SELF: 'checkout_gift_cards',
  BILLING_ADDRESS: 'checkout_gift_cards_billing_address',
  PAYMENT: 'checkout_gift_cards_payment',
  PAYMENT_RESULT: 'checkout_gift_cards_payment_result',
  WEBVIEW: {
    BILLING_ADDRESS: 'checkout_gift_cards_billing_address_webview',
    PAYMENT: 'checkout_gift_cards_payment_webview',
  },
}
